export const data = {
	"questionnaire": {
		"steps": [
			/* ============  step 0 =========== */
			{
				"stepId": "0",
				"stepName": "advisors",
				"stepTitle": "יועצים",
				"waitingTime": "10",
				"numberOfQuestionsMax": "5",
				"questions": [
					/* ====  qid 0 === */
					{
						"questionId": "0",
						"questionName": "intro",
						"questionType": "Input",
						"previousStep": "",
						"previousQuestion": "",
						"previousAnswer": "",
						"questionText": "פתיח",
						"CRMFlag": "concat",
						"CRM": [{ "q": "אני יועץ", "order": 0 }],
						"questionWithMultipleAnswers": false,
						"answer": {
							"nextStep": "0",
							"nextQuestion": "1",
							"fields": [
							]
						}
					},
					/* ====  qid 1 === */
					{
						"questionId": "1",
						"questionName": "whatsYourName",
						"questionType": "Input",
						"previousStep": "",
						"previousQuestion": "",
						"previousAnswer": "",
						"questionText": "?איך קוראים לך",
						"CRMFlag": "concat",
						"CRM": [{ "q": "?יועץ איך קוראים לך", "order": 0.1 }],
						"questionWithMultipleAnswers": false,
						"answer": {
							"nextStep": "0",
							"nextQuestion": "2",
							"fields": [
								{
									"answerText": "שם פרטי",
									"answerValue": ""
								},
								{
									"answerText": "שם משפחה",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 2 === */
					{
						"questionId": "2",
						"questionName": "whatsYourIdentityNumber",
						"questionType": "Input",
						"previousStep": "0",
						"previousQuestion": "1",
						"previousAnswer": "1",
						"questionText": "ת.ז",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "?יועץ מה מספר תעודת הזהות שלך", "order": 0.2 }],
						"answer": {
							"nextStep": "0",
							"nextQuestion": "3",
							"fields": [
								{
									"answerText": "ת.ז",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 3 === */
					{
						"questionId": "3",
						"questionName": "whatsYourTel",
						"questionType": "Input",
						"previousStep": "0",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "?מה מספר הטלפון שלך",
						"CRM": [{ "q": "?יועץ מה מספר הטלפון שלך", "order": 0.3 }],
						"questionWithMultipleAnswers": false,
						"answer": {
							"nextStep": "0",
							"nextQuestion": "4",
							"fields": [
								// {
								//     "answerTextPrefix": "בחר קידומת",
								//     "answerValue": ""
								// },
								{
									"answerText": "טלפון",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 4 === */
					{
						"questionId": "4",
						"questionName": "whatsYourEmail",
						"questionType": "Input",
						"previousStep": "0",
						"previousQuestion": "3",
						"previousAnswer": "1",
						"questionText": "אמייל",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "?יועץ מה האמייל שלך", "order": 0.4 }],
						"answer": {
							"nextStep": "0",
							"nextQuestion": "5",
							"fields": [
								{
									"answerText": "אמייל",
									"answerValue": ""
								}
							]
						}
                    },
                    /* ====  qid 5 === */
					{
						"questionId": "5",
						"questionName": "whatsYourEmail",
						"questionType": "Input",
						"previousStep": "0",
						"previousQuestion": "4",
						"previousAnswer": "1",
						"questionText": "מהי חברת הייעוץ שמעסיקה אותך?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "?יועץ מהי חברת הייעוץ שמעסיקה אותך", "order": 0.5 }],
						"answer": {
							"nextStep": "0",
							"nextQuestion": "6",
							"fields": [
								{
									"answerText": "חברת ייעוץ",
									"answerValue": ""
								}
							]
						}
                    },
					/* ====  qid 6 === */
					{
						"questionId": "6",
						"questionName": "consultingCompany",
						"questionType": "YesNo",
						"previousStep": "0",
						"previousQuestion": "5",
						"previousAnswer": "1",
						"questionText": "?יועץ מיחזור פנימי או חיצוני",
                        "questionWithMultipleAnswers": false,
                        "CRMOrder": 0.5,
						"selectedAnswer": "",
						"answersOptions": {
							"inner":
							{
								"answerId": "1",
								"nextStep": "1",
								"nextQuestion": "1",
								"answerText": "פנימי"
							},
							"outer":
							{
								"answerId": "2",
								"nextStep": "1",
								"nextQuestion": "1",
								"answerText": "חיצוני"
							}
						}
					}					
				]
			},

			/* ============  step 1 =========== */
			{
				"stepId": "1",
				"stepName": "user-details",
				"stepTitle": "פרטים אישיים",
				"waitingTime": "10",
				"numberOfQuestionsMax": "5",
				"questions": [
					/* ====  qid 1 === */
					{
						"questionId": "1",
						"questionName": "whatsYourName",
						"questionType": "Input",
						"previousStep": "",
						"previousQuestion": "",
						"previousAnswer": "",
						"questionText": "?איך קוראים לך",
						"CRMFlag": "concat",
						"CRM": [{ "q": "?איך קוראים לך", "order": 1 }],
						"questionWithMultipleAnswers": false,
						"answer": {
							"nextStep": "1",
							"nextQuestion": "2",
							"fields": [
								{
									"answerText": "שם פרטי",
									"answerValue": ""
								},
								{
									"answerText": "שם משפחה",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 2 === */
					{
						"questionId": "2",
						"questionName": "whatsYourIdentityNumber",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "1",
						"previousAnswer": "1",
						"questionText": "ת.ז",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "?מה מספר תעודת הזהות שלך", "order": 2 }],
						"answer": {
							"nextStep": "1",
							"nextQuestion": "3",
							"fields": [
								{
									"answerText": "ת.ז",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 3 === */
					{
						"questionId": "3",
						"questionName": "whatsYourTel",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "?מה מספר הטלפון שלך",
						"CRM": [{ "q": "?מה מספר הטלפון שלך", "order": 3 }],
						"questionWithMultipleAnswers": false,
						"answer": {
							"nextStep": "1",
							"nextQuestion": "4",
							"fields": [
								// {
								//     "answerTextPrefix": "בחר קידומת",
								//     "answerValue": ""
								// },
								{
									"answerText": "טלפון",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 4 === */
					{
						"questionId": "4",
						"questionName": "whatsYourEmail",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "3",
						"previousAnswer": "1",
						"questionText": "אמייל",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "?מה האמייל שלך", "order": 4 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "1",
							"fields": [
								{
									"answerText": "אמייל",
									"answerValue": ""
								}
							]
						}
					}
				]
			},

			/* ============  step 2 =========== */
			{
				"stepId": "2",
				"stepName": "cycle-details",
				"stepTitle": "פרטי המחזור",
				"waitingTime": "10",
				"numberOfQuestionsMax": "15",
				"questions": [
					/* ====  qid 1 === */
					{
						"questionId": "1",
						"isJunction": true,
						"questionName": "WhatsThePurpose",
						"questionType": "YesNo",
						"previousStep": "1",
						"previousQuestion": "",
						"previousAnswer": "",
						"questionText": "מהי מטרת המחזור?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 5,
						"selectedAnswer": "",
						"answersOptions": {
							"extensionPeriod":
							{
								"answerId": "1",
								"nextStep": "2",
								"nextQuestion": "2",
								"answerText": "הארכת תקופה"
							},
							"improveRate":
							{
								"answerId": "2",
								"nextStep": "2",
								"nextQuestion": "2",
								"answerText": "שיפור ריבית"
							},
							"shortPeriod":
							{
								"answerId": "3",
								"nextStep": "2",
								"nextQuestion": "2",
								"answerText": "קיצור תקופה"
							},
							"mixChange":
							{
								"answerId": "4",
								"nextStep": "2",
								"nextQuestion": "2",
								"answerText": "שינוי תמהיל"
							},
							"takeCredit":
							{
								"answerId": "5",
								"nextStep": "2",
								"nextQuestion": "2",
								"answerText": "לקיחת אשראי נוסף",
							}
						}
					},
					/* ====  qid 2 === */
					{
						"questionId": "2",
						"questionName": "cycleAmount",
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "מהו ההחזר החודשי?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהו ההחזר החודשי?", "order": 6 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "3",
							"fields": [
								{
									"answerText": "החזר חודשי",
									"answerValue": ""
								}
							]
						}
					},


					/* ====  qid 2-0 - advisor === */
					{
						"questionId": "2-0",
						"questionName": "isHigherThanTheExistingOne",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "2",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "האם סכום ההחזר החודשי שבחרת גבוה מההחזר הקיים?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 6.1,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "2",
								"nextQuestion": "2-1",
								"answerText": "כן"
							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "2",
								"nextQuestion": "2-1",
								"answerText": "לא"
							}
						}
					},


					/* ====  qid 2-1 - advisor === */
					{
						"questionId": "2-1",
						"questionName": "cycleMixture",
						"questionType": "InputArray",
						"previousStep": "2",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "תמהיל מבוקש",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "סוג מסלול", "order": 10.1 },
						{ "q": "סכום מבוקש של המסלול", "order": 10.2 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "3",
                            "fieldsArray": [
                                [{
                                    "answerText": "סוג מסלול",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום מבוקש",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                }]
                            ]
						}
					},

					/* ====  qid 3 - external === */
					{
						"questionId": "3",
						"questionName": "externalBank",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "באיזה בנק מתנהלת המשכנתא שלך?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "באיזה בנק מתנהלת המשכנתא שלך?", "order": 7 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "4",
							"fields": [
								{
									"answerText": "באיזה בנק מתנהלת המשכנתא שלך?",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 4 - external === */
					{
						"questionId": "4",
						"questionName": "externalMakorPropose",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "3",
						"previousAnswer": "",
						"questionText": "לאיזו מטרה נלקחה המשכנתא במקור?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "לאיזו מטרה נלקחה המשכנתא במקור?", "order": 8 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "5",
							"fields": [
								{
									"answerText": "לאיזו מטרה נלקחה המשכנתא במקור?",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 5 - external === */
					{
						"questionId": "5",
						"questionName": "externalMortgageBalance",
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "4",
						"previousAnswer": "",
						"questionText": "מהי יתרת המשכנתא בבנק האחר? (כולל עמלות פירעון)",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהי יתרת המשכנתא בבנק האחר? (כולל עמלות פירעון)", "order": 9 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "6",
							"fields": [
								{
									"answerText": "יתרת המשכנתא בבנק האחר",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 6 - external === */
					{
						"questionId": "6",
						"questionName": "externalMonthlyRepayment",
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "5",
						"previousAnswer": "",
						"questionText": "מהו ההחזר החודשי במשכנתא הנוכחית?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהו ההחזר החודשי במשכנתא הנוכחית?", "order": 10 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "7",
							"fields": [
								{
									"answerText": "מהו ההחזר החודשי במשכנתא הנוכחית?",
									"answerValue": ""
								}
							]
						}
					},

					/* ====  qid 7 - external === */
					{
						"questionId": "7",
						"questionName": "inWhichCity",
						"questionType": "Input",
						"previousStep": "1",
						"previousQuestion": "6",
						"previousAnswer": "",
						"questionText": "באיזו עיר נמצא הנכס?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "באיזו עיר נמצא הנכס?", "order": 11 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "8",
							"fields": [
								{
									"answerText": "באיזו עיר נמצא הנכס?",
									"answerValue": ""
								}
							]
						}
					},
					/* ====  qid 8 - external === */
					{
						"questionId": "8",
						"questionName": "cycleAmount",
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "7",
						"previousAnswer": "",
						"questionText": "מהו שווי הנכס להערכתך?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהו שווי הנכס להערכתך?", "order": 12 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "1",
							"fields": [
								{
									"answerText": "שווי הנכס",
									"answerValue": ""
								}
							]
						}
					},





					/* ====  qid 9 - internal === */
					{
						"questionId": "9",
						"questionName": "internalAreCycleAllMorygage",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "2",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "רוצה למחזר את כל המשכנתא?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 6.1,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "3",
								"nextQuestion": "1",
								"answerText": "כן"
							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "2",
								"nextQuestion": "9-1",
								"answerText": "לא"
							}
						}
					},

					/* ====  qid 9-1 - internal === */
					{
						"questionId": "9-1",
						"questionName": "internalCycleAmount",
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "9",
						"previousAnswer": "",
						"questionText": "מה הסכום למחזור?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מה הסכום למחזור?", "order": 6.2 }],
						"answer": {
							"nextStep": "2",
							"nextQuestion": "9-2",
							"fields": [
								{
									"answerText": "הסכום למחזור",
									"answerValue": ""
								}
							]
						}
					},
                    /* ====  qid 9-2 - internal === */
                    {
                        "questionId": "9-2",
                        "questionName": "internalTikNum",
                        "questionType": "InputArray",
                        "previousStep": "2",
                        "previousQuestion": "9",
                        "previousAnswer": "",
                        "questionText": "מספר התיק למיחזור",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{"q":"מספר התיק למיחזור", "order":6.3}],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "9-3",
                            "fieldsArray": [
                                [{
                                    "answerText": "מספר התיק למחזור",
                                    "answerKey": "internalTikNum",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
					/* ====  qid 9-3 - internal === */
					{
						"questionId": "9-3",
						"questionName": "internalMaslol",
						"questionType": "InputArray",
						"previousStep": "2",
						"previousQuestion": "9",
						"previousAnswer": "",
						"questionText": "איזה מסלול תרצה למחזר?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "איזה מסלול תרצה למחזר?", "order": 6.4 }],
						"answer": {
							"nextStep": "3",
                            "nextQuestion": "1",
                            "fieldsArray": [
                                [{
                                    "answerText": "מסלול למחזור",
                                    "answerKey": "internalMaslol",
                                    "answerValue": ""
                                }]
                            ]
						}
					},
					/* ====  qid 9-4 - internal === */
					// {
					// 	"questionId": "9-4",
					// 	"questionName": "internalProduct",
					// 	"questionType": "Input",
					// 	"previousStep": "2",
					// 	"previousQuestion": "9",
					// 	"previousAnswer": "",
					// 	"questionText": "לאיזה מוצר תרצה להעביר את הסכום החדש?",
					// 	"questionWithMultipleAnswers": false,
					// 	"CRM": [{ "q": "לאיזה מוצר תרצה להעביר את הסכום החדש?", "order": 6.5 }],
					// 	"answer": {
					// 		"nextStep": "3",
					// 		"nextQuestion": "1",
					// 		"fields": [
					// 			{
					// 				"answerText": "לאיזה מוצר תרצה להעביר את הסכום החדש?",
					// 				"answerValue": ""
					// 			}
					// 		]
					// 	}
					// },












				// לאיזה סניף תרצה להגיע בכדי להתקדם במשכנתא במידה ותהיה כדאיות?***************					
					/* ====  qid 10 - advisor external === */
					{
						"questionId": "10",
						"questionName": "continueBranch",
						"isJunction": false,
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "8",
						"previousAnswer": "",
						"questionText": "לאיזה סניף תרצה להגיע בכדי להתקדם במשכנתא במידה ותהיה כדאיות?",
						"questionWithMultipleAnswers": false,
						"CRMOrder": 10,
						"answer": {
							"nextStep": "2",
							"nextQuestion": "11",
							"fields": [
								{
									"answerText": "לאיזה סניף תרצה להגיע בכדי להתקדם במשכנתא במידה ותהיה כדאיות",
									"answerValue": ""
								}
							]
						}
					},

// היכן מתנהל חשבון העובר ושב שלך ***************
					/* ====  qid 11 -  advisor external === */
					{
						"questionId": "11",
						"questionName": "oshBank",
						"isJunction": false,
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "10",
						"previousAnswer": "",
						"questionText": "היכן מתנהל חשבון העובר ושב שלך?",
						"questionWithMultipleAnswers": false,
						"CRMOrder": 11,
						"selectedAnswer": "",
						"answer": {
							"nextStep": "3",
							"nextQuestion": "1",
							"fields": [
								{
									"answerText": "היכן מתנהל חשבון העובר ושב שלך",
									"answerValue": ""
								}
							]
						}
					},




				]
			},







			/* ============  step 3 =========== */
			{
				"stepId": "3",
				"stepName": "user-more-details",
				"stepTitle": "פרטי הלקוח ותעסוקתו",
				"waitingTime": "10",
				"numberOfQuestionsMax": "20",
				"questions": [
					{
						"questionId": "1",
						"questionName": "moreUserDetails",
						"isJunction": true,
						"questionType": "Input",
						"previousStep": "2",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "מספר פרטים נוספים",
						"questionWithMultipleAnswers": false,
						"CRM": [
							{ "q": " מה תאריך הלידה?", "order": 13 },
							{ "q": " מה מצבך המשפחתי?", "order": 14 },
							{ "q": "כמה ילדים יש בבית מתחת לגיל 18?", "order": 15 },
							{ "q": "השכלה", "order": 16 }
						],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "2",
							"fields": [
								{
									"answerText": "תאריך לידה",
									"answerValue": ""
								},
								{
									"answerText": "מצב משפחתי",
									"answerValue": ""
								},
								{
									"answerText": "מספר ילדים",
									"answerValue": ""
								},

								{
									"answerText": "השכלה",
									"answerValue": ""
								},
								{
									"answerText": "מצב תעסוקתי",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "2",
						"questionName": "statusEmployment",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "3",
						"previousQuestion": "1",
						"previousAnswer": "1",
						"questionText": "מצב התעסוקתי",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 17,
						"selectedAnswer": "",
						"answersOptions": {
							"employee":
							{
								"answerId": "1",
								"nextStep": "3",
								"nextQuestion": "3.1-a",
								"answerText": "שכיר"
							},
							"independent":
							{
								"answerId": "2",
								"nextStep": "3",
								"nextQuestion": "3.2-a",
								"answerText": "עצמאי"
							},
							"unemployed":
							{
								"answerId": "3",
								"nextStep": "3",
								"nextQuestion": "4",
								"answerText": "לא עובד"
							},
							"employeeAndIndependent":
							{
								"answerId": "4",
								"nextStep": "3",
								"nextQuestion": "3.1-a",
								"answerText": "גם עצמאי וגם שכיר"
							}
						}
					},

					//Employee
					{
						"questionId": "3.1-a",
						"questionName": "employersCompanyName",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "שם המעסיק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם המעסיק", "order": 18.1 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "3.1-b",
							"fields": [
								{
									"answerText": "שם המעסיק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "3.1-b",
						"questionName": "employersMulty",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "3.1-a",
						"previousAnswer": "1",
						"questionText": "תחום עיסוק, מקצועך ושנות ותק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "תחום עיסוק", "order": 19.1 }, { "q": "מקצוע", "order": 20.1 }, { "q": "שנות ותק", "order": 21.2 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "3.1-c",
							"fields": [
								{
									"answerText": "תחום עיסוק",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות ותק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "3.1-c",
						"questionName": "employersMonthlyIncome",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "3.1-b",
						"previousAnswer": "1",
						"questionText": "הכנסה חודשית",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "הכנסה חודשית", "order": 22.1 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "4",
							"fields": [
								{
									"answerText": "הכנסה חודשית",
									"answerValue": ""
								}
							]
						}
					},

					//Independent
					{
						"questionId": "3.2-a",
						"questionName": "independentCompanyName",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "שם העסק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם העסק", "order": 18.2 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "3.2-b",
							"fields": [
								{
									"answerText": "שם העסק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "3.2-b",
						"questionName": "independentMulty",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "3.2-a",
						"previousAnswer": "1",
						"questionText": "תחום פעילות, מקצועך ושנות פעילות",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "תחום פעילות", "order": 19.2 }, { "q": "מקצוע", "order": 20.2 }, { "q": "שנות פעילות", "order": 21.2 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "3.2-c",
							"fields": [
								{
									"answerText": "תחום פעילות",
									"answerValue": ""
								},
								{
									"answerText": "מקצועך",
									"answerValue": ""
								},
								{
									"answerText": "שנות פעילות",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "3.2-c",
						"questionName": "independentYearlyIncome",
						"questionType": "Input",
						"previousStep": "3",
						"previousQuestion": "3.2-b",
						"previousAnswer": "1",
						"questionText": "הכנסה שנתית",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "הכנסה שנתית", "order": 22.2 }],
						"answer": {
							"nextStep": "3",
							"nextQuestion": "4",
							"fields": [
								{
									"answerText": "הכנסה שנתית",
									"answerValue": ""
								}
							]
						}
					},

					//Additional Income
					{
						"questionId": "4",
						"questionName": "areThereOtherIncome",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "3",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "האם יש לך הכנסות נוספות?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 23,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "3",
								"nextQuestion": "4-1",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "1",
								"answerText": "לא"

							}
						}
					},
					{
						"questionId": "4-1",
						"questionName": "additionalIncome",
						"questionType": "InputArray",
						"previousStep": "3",
						"previousQuestion": "4",
						"previousAnswer": "",
						"questionText": "ההכנסות הנוספות",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "סוג ההכנסה", "order": 23.1 },
						{ "q": "מה סכום ההכנסה החודשי נטו?", "order": 23.2 },
						{ "q": "פירוט ההכנסה", "order": 23.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "1",
							"fieldsArray": [
								[{
									"answerText": "סוג הכנסה נוספת",
									"answerKey": "type",
									"answerValue": ""
								},
								{
									"answerText": "סכום ההכנסה החודשי",
									"answerKey": "amount",
									"answerValue": ""
								},
								{
									"answerText": "פירוט ההכנסה",
									"answerKey": "source",
									"answerValue": ""
								}]
							]
						}
					}
				]
			},

			/* ============  step 4 =========== */
			{
				"stepId": "4",
				"stepName": "borrowers-details",
				"stepTitle": "לוים נוספים",
				"waitingTime": "10",
				"numberOfQuestionsMax": "100",
				"questions": [
					{
						"questionId": "1",
						"questionName": "additionalBorrowers",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "3",
						"previousQuestion": "1",
						"previousAnswer": "1",
						"questionText": " האם יש לווים נוספים?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 26,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "2",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "5",
								"nextQuestion": "1",
								"answerText": "לא"

							}
						}
					},

					// borrower Array - main Q
					{
						"questionId": "2",
						"questionName": "additionalBorrowersDetails1",
						"isJunction": true,
						"nextIfHasBorrower": true,
						"questionType": "Borrower",
						"previousStep": "3",
						"previousQuestion": "1",
						"previousAnswer": "1",
						"questionText": " פרטי הלווים הנוספים",
						"questionWithMultipleAnswers": false,
						"CRM": [
							{ "q": "קרבה הלווה", "order": 27.2 },
							{ "q": "שם לווה", "order": 27.3 },
							{ "q": "תעודת זהות לווה", "order": 27.4 },
							{ "q": "טלפון לווה", "order": 27.5 },
							{ "q": "תאריך לידה לווה", "order": 27.6 },
							{ "q": "דואל אלקטרוני הלווה", "order": 27.7 }
						],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "3-1",
							"answer-data": [
								{
									borrowerId: "1",
									"fields": [
										{
											"answerText": "קרבה לווה",
											"answerKey": "borrowerProximity",
											"answerValue": ""
										},
										{
											"answerText": "שם לווה",
											"answerKey": "borrowerFullName",
											"answerValue": ""
										},
										{
											"answerText": "תעודת זהות לווה",
											"answerKey": "borrowerIdNumber",
											"answerValue": ""
										},
										{
											"answerText": "טלפון לווה",
											"answerKey": "borrowerPhoneNumber",
											"answerValue": ""
										},
										{
											"answerText": "תאריך לידה לווה",
											"answerKey": "borrowerBirthDate",
											"answerValue": ""
										},
										{
											"answerText": "דואר אלקטרוני לווה",
											"answerKey": "borrowerEmail",
											"answerValue": ""
										}
									]
								},
								{
									borrowerId: "2",
									"fields": [
										{
											"answerText": "קרבה לווה",
											"answerKey": "borrowerProximity",
											"answerValue": ""
										},
										{
											"answerText": "שם לווה",
											"answerKey": "borrowerFullName",
											"answerValue": ""
										},
										{
											"answerText": "תעודת זהות לווה",
											"answerKey": "borrowerIdNumber",
											"answerValue": ""
										},
										{
											"answerText": "טלפון לווה",
											"answerKey": "borrowerPhoneNumber",
											"answerValue": ""
										},
										{
											"answerText": "תאריך לידה לווה",
											"answerKey": "borrowerBirthDate",
											"answerValue": ""
										},
										{
											"answerText": "דואר אלקטרוני לווה",
											"answerKey": "borrowerEmail",
											"answerValue": ""
										}


									]
								},
								{
									borrowerId: "3",
									"fields": [
										{
											"answerText": "קרבה לווה",
											"answerKey": "borrowerProximity",
											"answerValue": ""
										},
										{
											"answerText": "שם לווה",
											"answerKey": "borrowerFullName",
											"answerValue": ""
										},
										{
											"answerText": "תעודת זהות לווה",
											"answerKey": "borrowerIdNumber",
											"answerValue": ""
										},
										{
											"answerText": "טלפון לווה",
											"answerKey": "borrowerPhoneNumber",
											"answerValue": ""
										},
										{
											"answerText": "תאריך לידה לווה",
											"answerKey": "borrowerBirthDate",
											"answerValue": ""
										},
										{
											"answerText": "דואר אלקטרוני לווה",
											"answerKey": "borrowerEmail",
											"answerValue": ""
										}
									]
								}
							]

						}
					},

					// borrower 1
					{
						"questionId": "3-1",
						"questionName": "brwEmploymentStatus",
						"isJunction": true,
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "מהו המצב התעסוקתי של XX?",
						"questionWithMultipleAnswers": true,
						"questionType": "YesNo",
						"CRMOrder": 28,
						"selectedAnswer": "",
						"answersOptions": {
							"employee":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "4a-1",
								"answerText": "שכיר"
							},
							"independent":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "4b-1",
								"answerText": "עצמאי"
							},
							"unemployed":
							{
								"answerId": "3",
								"nextStep": "4",
								"nextQuestion": "7a-1",
								"answerText": "לא עובד"
							},
							"employeeAndIndependent":
							{
								"answerId": "4",
								"nextStep": "4",
								"nextQuestion": "4a-1",
								"answerText": "גם עצמאי וגם שכיר"
							}
						},
					},

					//borrower 1 - Employers
					{
						"questionId": "4a-1",
						"questionName": "brwEmployersCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "שם המעסיק של XX?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם המעסיק של XX?", "order": 29 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5a-1",
							"fields": [
								{
									"answerText": "שם המעסיק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5a-1",
						"questionName": "brwEmployersMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, תחום עיסוק, מקצועך ושנות ותק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "תחום עיסוק של XX?", "order": 30.1 }, { "q": "מקצועו של XX?", "order": 30.2 }, { "q": "שנות ותק של XX?", "order": 30.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6a-1",
							"fields": [
								{
									"answerText": "תחום עיסוק",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות ותק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6a-1",
						"questionName": "brwEmployersMonthlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "ההכנסה החודשית של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "ההכנסה החודשית של XX", "order": 31 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-1",
							"fields": [
								{
									"answerText": "הכנסה חודשית",
									"answerValue": ""
								}
							]
						}
					},

					//borrower 1 - Independent
					{
						"questionId": "4b-1",
						"questionName": "brwIndependentCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, מהו שם העסק?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, מהו שם העסק?", "order": 32 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5b-1",
							"fields": [
								{
									"answerText": "שם העסק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5b-1",
						"questionName": "brwIndependentMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, תהו תחום פעילות, מקצועך ושנות פעילות",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, מהו תחום הפעילות?", "order": 33.1 }, { "q": "XX, מהו מקצועך?", "order": 33.2 }, { "q": "XX, מהם שנות פעילות?", "order": 33.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6b-1",
							"fields": [
								{
									"answerText": "תחום פעילות",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות פעילות",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6b-1",
						"questionName": "brwIndependentYearlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "מהי ההכנסה השנתית של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהי ההכנסה השנתית של XX", "order": 34 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-1",
							"fields": [
								{
									"answerText": "הכנסה שנתית",
									"answerValue": ""
								}
							]
						}
					},

					//borrower 1 - incoms
					{
						"questionId": "7a-1",
						"questionName": "brwAreThereOtherIncome",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "האם יש לך הכנסות נוספות XX?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 35,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "7b-1",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "3-2",
								"answerText": "לא"

							}
						}
					},
					{
						"questionId": "7b-1",
						"questionName": "brwAdditionalIncome",
						"questionType": "InputArray",
						"isLastQuestionForBorrower": true,
						"previousStep": "4",
						"previousQuestion": "7a-1",
						"previousAnswer": "",
						"questionText": "הכנסות נוספות של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "סוג ההכנסה של XX", "order": 35.1 },
						{ "q": "סכום ההכנסה החודשי נטו של XX", "order": 35.2 },
						{ "q": "פירוט ההכנסה של XX", "order": 35.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "3-2",
							"fieldsArray": [
								[{
									"answerText": "סוג הכנסה נוספת",
									"answerKey": "type",
									"answerValue": ""
								},
								{
									"answerText": "סכום ההכנסה החודשי",
									"answerKey": "amount",
									"answerValue": ""
								},
								{
									"answerText": "פירוט ההכנסה",
									"answerKey": "source",
									"answerValue": ""
								}]
							]
						}
					},

					// borrower 2
					{
						"questionId": "3-2",
						"questionName": "brwEmploymentStatus",
						"isJunction": true,
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "מהו המצב התעסוקתי של XX?",
						"questionWithMultipleAnswers": true,
						"questionType": "YesNo",
						"CRMOrder": 36,
						"selectedAnswer": "",
						"answersOptions": {
							"employee":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "4a-2",
								"answerText": "שכיר"
							},
							"independent":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "4b-2",
								"answerText": "עצמאי"
							},
							"unemployed":
							{
								"answerId": "3",
								"nextStep": "4",
								"nextQuestion": "7a-2",
								"answerText": "לא עובד"
							},
							"employeeAndIndependent":
							{
								"answerId": "4",
								"nextStep": "4",
								"nextQuestion": "4a-2",
								"answerText": "גם עצמאי וגם שכיר"
							}
						}
					},

					//borrower 2 - Employers
					{
						"questionId": "4a-2",
						"questionName": "brwEmployersCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "שם המעסיק של XX?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם המעסיק של XX", "order": 37 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5a-2",
							"fields": [
								{
									"answerText": "שם המעסיק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5a-2",
						"questionName": "brwEmployersMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, מהו תחום עיסוק, מקצוע ושנות ותק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "תחום העיסוק של XX", "order": 38.1 }, { "q": "מקצועו של XX", "order": 38.2 }, { "q": "ושנות ותק של XX", "order": 38.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6a-2",
							"fields": [
								{
									"answerText": "תחום עיסוק",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות ותק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6a-2",
						"questionName": "brwEmployersMonthlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "ההכנסה החודשית של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "ההכנסה החודשית של XX", "order": 39 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-2",
							"fields": [
								{
									"answerText": "הכנסה חודשית",
									"answerValue": ""
								}
							]
						}
					},
					//borrower 2 - Independent
					{
						"questionId": "4b-2",
						"questionName": "brwIndependentCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "מהו שם העסק של XX?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם העסק של XX", "order": 40 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5b-2",
							"fields": [
								{
									"answerText": "שם העסק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5b-2",
						"questionName": "brwIndependentMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, מהו תחום פעילות, מקצועך ושנות פעילות",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, תחום פעילות", "order": 41.1 }, { "q": "מקצועו של XX", "order": 41.2 }, { "q": "XX, שנות פעילות", "order": 41.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6b-2",
							"fields": [
								{
									"answerText": "תחום פעילות",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות פעילות",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6b-2",
						"questionName": "brwIndependentYearlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, הכנסה שנתית",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, הכנסה שנתית", "order": 42 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-2",
							"fields": [
								{
									"answerText": "הכנסה שנתית",
									"answerValue": ""
								}
							]
						}
					},

					//borrower 2 - incoms
					{
						"questionId": "7a-2",
						"questionName": "brwAreThereOtherIncome",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, האם יש לך הכנסות נוספות?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 43,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "7b-2",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "3-3",
								"answerText": "לא"

							}
						}
					},
					{
						"questionId": "7b-2",
						"questionName": "brwAdditionalIncome",
						"questionType": "InputArray",
						"isLastQuestionForBorrower": true,
						"previousStep": "4",
						"previousQuestion": "7a-2",
						"previousAnswer": "",
						"questionText": "הכנסות נוספות של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, מה סוג ההכנסה?", "order": 43.1 },
						{ "q": "XX, מה סכום ההכנסה החודשי נטו?", "order": 43.2 },
						{ "q": "XX, פירוט ההכנסה", "order": 43.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "3-3",
							"fieldsArray": [
								[{
									"answerText": "סוג הכנסה נוספת",
									"answerKey": "type",
									"answerValue": ""
								},
								{
									"answerText": "סכום ההכנסה החודשי",
									"answerKey": "amount",
									"answerValue": ""
								},
								{
									"answerText": "פירוט ההכנסה",
									"answerKey": "source",
									"answerValue": ""
								}]
							]
						}
					},

					// borrower 3
					{
						"questionId": "3-3",
						"questionName": "brwEmploymentStatus",
						"isJunction": true,
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "מהו המצב התעסוקתי של XX?",
						"questionWithMultipleAnswers": true,
						"questionType": "YesNo",
						"CRMOrder": 44,
						"selectedAnswer": "",
						"answersOptions": {
							"employee":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "4a-3",
								"answerText": "שכיר"
							},
							"independent":
							{
								"answerId": "2",
								"nextStep": "4",
								"nextQuestion": "4b-3",
								"answerText": "עצמאי"
							},
							"unemployed":
							{
								"answerId": "3",
								"nextStep": "4",
								"nextQuestion": "7a-3",
								"answerText": "לא עובד"
							},
							"employeeAndIndependent":
							{
								"answerId": "4",
								"nextStep": "4",
								"nextQuestion": "4a-3",
								"answerText": "גם עצמאי וגם שכיר"
							}
						}
					},

					//borrower 3 - Employers
					{
						"questionId": "4a-3",
						"questionName": "brwEmployersCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "שם המעסיק של XX?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "שם המעסיק של XX?", "order": 45 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5a-3",
							"fields": [
								{
									"answerText": "שם המעסיק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5a-3",
						"questionName": "brwEmployersMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, תחום עיסוק, מקצועך ושנות ותק",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "תחום העיסוק של XX", "order": 46.1 }, { "q": "מקצועו של XX", "order": 46.2 }, { "q": "ושנות ותק של XX?", "order": 46.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6a-3",
							"fields": [
								{
									"answerText": "תחום עיסוק",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות ותק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6a-3",
						"questionName": "brwEmployersMonthlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "1",
						"questionText": "XX, הכנסה חודשית",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, הכנסה חודשית", "order": 47 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-3",
							"fields": [
								{
									"answerText": "הכנסה חודשית",
									"answerValue": ""
								}
							]
						}
					},
					//borrower 3 - Independent
					{
						"questionId": "4b-3",
						"questionName": "brwEmployersCompanyName",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, מהו שם העסק?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, מהו שם העסק?", "order": 48 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "5b-3",
							"fields": [
								{
									"answerText": "שם העסק",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "5b-3",
						"questionName": "brwIndependentMulty",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, תחום פעילות, מקצועך ושנות פעילות",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, תחום פעילות", "order": 49.1 }, { "q": "מקצועו של XX", "order": 49.2 }, { "q": "XX, שנות פעילות", "order": 49.3 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "6b-3",
							"fields": [
								{
									"answerText": "תחום פעילות",
									"answerValue": ""
								},
								{
									"answerText": "מקצוע",
									"answerValue": ""
								},
								{
									"answerText": "שנות פעילות",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "6b-3",
						"questionName": "brwIndependentYearlyIncome",
						"questionType": "Input",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, הכנסה שנתית",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, הכנסה שנתית", "order": 50 }],
						"answer": {
							"nextStep": "4",
							"nextQuestion": "7a-3",
							"fields": [
								{
									"answerText": "הכנסה שנתית",
									"answerValue": ""
								}
							]
						}
					},

					//borrower 3 incoms
					{
						"questionId": "7a-3",
						"questionName": "brwAreThereOtherIncome",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "XX, האם יש לך הכנסות נוספות?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 51,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "4",
								"nextQuestion": "7b-3",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "5",
								"nextQuestion": "1",
								"answerText": "לא"

							}
						}
					},
					{
						"questionId": "7b-3",
						"questionName": "brwAdditionalIncome",
						"questionType": "InputArray",
						"isLastQuestionForBorrower": true,
						"previousStep": "4",
						"previousQuestion": "7a-3",
						"previousAnswer": "",
						"questionText": "הכנסות נוספות של XX",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "XX, מה סוג ההכנסה?", "order": 51.1 },
						{ "q": "XX, מה סכום ההכנסה החודשי נטו?", "order": 51.2 },
						{ "q": "XX, פירוט ההכנסה", "order": 51.3 }],
						"answer": {
							"nextStep": "5",
							"nextQuestion": "1",
							"fieldsArray": [
								[{
									"answerText": "סוג הכנסה נוספת",
									"answerKey": "type",
									"answerValue": ""
								},
								{
									"answerText": "סכום ההכנסה החודשי",
									"answerKey": "amount",
									"answerValue": ""
								},
								{
									"answerText": "פירוט ההכנסה",
									"answerKey": "source",
									"answerValue": ""
								}]
							]
						}
					}
				]
			},

			/* ============  step 5 =========== */
			{
				"stepId": "5",
				"stepName": "liabilities",
				"stepTitle": "התחייבויות",
				"waitingTime": "10",
				"numberOfQuestionsMax": "5",
				"questions": [
					{
						"questionId": "1",
						"questionName": "haveYouLiabilities",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "4",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "האם יש לך התחייבויות?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 52,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "5",
								"nextQuestion": "2",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "6",
								"nextQuestion": "1",
								"answerText": "לא"
							}
						}
					},
					{
						"questionId": "2",
						"questionName": "whichLiabilities",
						"questionType": "InputArray",
						"previousStep": "5",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "האם מלבד המשכנתא יש לך התחייבויות נוספות שמסתיימות בעוד יותר משנה וחצי?",
						"questionWithMultipleAnswers": false,
						"CRM": [
							{ "q": "סוג ההתחייבויות", "order": 53.1 },
							{ "q": "יתרת ההתחייבויות", "order": 53.2 },
							{ "q": "סכום החזר חודשי", "order": 53.3 }
						],
						"answer": {
							"nextStep": "6",
							"nextQuestion": "1",
							"fieldsArray": [
								[{
									"answerText": "סוג התייחבות",
									"answerKey": "liabilityType",
									"answerValue": ""
								},
								{
									"answerText": "מה סכום היתרה?",
									"answerKey": "liabilityBalance",
									"answerValue": ""
								},
								{
									"answerText": "מה סכום ההחזר החודשי?",
									"answerKey": "liabilityMonthlyRefund",
									"answerValue": ""
								}]
							]
						}
					}
				]
			},

			/* ============  step 6 =========== */
			{
				"stepId": "6",
				"stepName": "financing-sources",
				"stepTitle": "אשראי נוסף",
				"waitingTime": "10",
				"numberOfQuestionsMax": "3",
				"questions": [
					{
						"questionId": "1",
						"questionName": "haveMoreLoan",
						"isJunction": true,
						"questionType": "YesNo",
						"previousStep": "5",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "האם את/ה זקוק/ה לאשראי נוסף?",
						"questionWithMultipleAnswers": true,
						"CRMOrder": 54,
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"nextStep": "6",
								"nextQuestion": "2",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"nextStep": "7",
								"nextQuestion": "1",
								"isLastQuestion": true,
								"answerText": "לא"
							}
						}
					},
					{
						"questionId": "2",
						"questionName": "loanPropose",
						"questionType": "Input",
						"previousStep": "6",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "מהי מטרת ההלוואה?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהי מטרת ההלוואה?", "order": 55 }],
						"answer": {
							"nextStep": "6",
							"nextQuestion": "3",
							"fields": [
								{
									"answerText": "מטרת ההלוואה",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "3",
						"questionName": "loanAmount",
						"questionType": "Input",
						"previousStep": "6",
						"previousQuestion": "2",
						"previousAnswer": "",
						"questionText": "מהו סכום ההלוואה המבוקש?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "מהו סכום ההלוואה המבוקש?", "order": 56 }],
						"answer": {
							"nextStep": "7",
							"nextQuestion": "1",
							"isLastQuestion": true,
							"fields": [
								{
									"answerText": "סכום ההלוואה המבוקש",
									"answerValue": ""
								}
							]
						}
					}
				]
			},

			/* ============  SUMMERY =========== */
			{
				"stepId": "7",
				"stepName": "summarize",
				"stepTitle": "סיכום",
				"numberOfQuestionsMax": "2",
				"questions": [
					{
						"questionId": "1",
						"questionName": "what else",
						"questionType": "Input",
						"previousStep": "6",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "יש לך עוד משהו לספר לנו?",
						"questionWithMultipleAnswers": false,
						"CRM": [{ "q": "יש לך עוד משהו לספר לנו?", "order": 57 }],
						"answer": {
							"nextStep": "",
							"nextQuestion": "",
							"fields": [
								{
									"answerText": "יש לך עוד משהו לספר לנו?",
									"answerValue": ""
								}
							]
						}
					},
					{
						"questionId": "2",
						"questionName": "marketing",
						"questionType": "YesNo",
						"previousStep": "6",
						"previousQuestion": "1",
						"previousAnswer": "",
						"questionText": "מסכים למידע שיווקי?",
						"questionWithMultipleAnswers": true,
						"CRM": [{ "q": "מסכים למידע שיווקי?", "order": 58 }],
						"selectedAnswer": "",
						"answersOptions": {
							"YES":
							{
								"answerId": "1",
								"answerText": "כן"

							},
							"NO":
							{
								"answerId": "2",
								"answerText": "לא"
							}
						}
					}


				]
			}
		]
	}
}


// WEBPACK FOOTER //
// ./src/data.ts